var _g, _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 127,
    viewBox: "0 0 128 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_920_97947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9698 43.3183L69.0298 36.2583C72.0189 33.5338 75.9429 32.0659 79.9863 32.1595C84.0296 32.2531 87.8815 33.9011 90.7413 36.7609C93.6012 39.6208 95.2491 43.4726 95.3427 47.5159C95.4363 51.5593 93.9684 55.4833 91.244 58.4724L81.1531 68.5276C79.6988 69.9874 77.9706 71.1456 76.0676 71.9359C74.1647 72.7262 72.1244 73.1331 70.0639 73.1331C68.0033 73.1331 65.963 72.7262 64.0601 71.9359C62.1571 71.1456 60.4289 69.9874 58.9746 68.5276",
    stroke: "black",
    strokeWidth: 2.97656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0325 83.6761L58.9724 90.7361C55.9833 93.4606 52.0593 94.9285 48.016 94.8349C43.9726 94.7413 40.1208 93.0934 37.2609 90.2335C34.4011 87.3736 32.7531 83.5218 32.6595 79.4785C32.5659 75.4351 34.0338 71.5111 36.7583 68.522L46.8491 58.4668C48.3034 57.0071 50.0316 55.8488 51.9346 55.0585C53.8376 54.2682 55.8778 53.8613 57.9384 53.8613C59.9989 53.8613 62.0392 54.2682 63.9422 55.0585C65.8451 55.8488 67.5733 57.0071 69.0276 58.4668",
    stroke: "black",
    strokeWidth: 2.97656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 63.5,
    r: 8.92969,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 0.776495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.769 60.77C67.9964 60.5426 67.9964 60.1739 67.769 59.9465C67.5415 59.719 67.1728 59.719 66.9454 59.9465L64.1074 62.7845L61.27 59.9472C61.0426 59.7197 60.6739 59.7197 60.4465 59.9472C60.219 60.1746 60.219 60.5433 60.4465 60.7707L63.2838 63.6081L60.4465 66.4454C60.219 66.6728 60.219 67.0415 60.4465 67.269C60.6739 67.4964 61.0426 67.4964 61.27 67.269L64.1074 64.4316L66.9454 67.2697C67.1728 67.4971 67.5415 67.4971 67.769 67.2697C67.9964 67.0422 67.9964 66.6735 67.769 66.4461L64.9309 63.6081L67.769 60.77Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.869 46.5665L32.7997 45.876M44.6521 38.6953L36.7345 31.8178M53.4822 31.4895L50.8914 26.2929",
    stroke: "black",
    strokeWidth: 1.98438,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3085 74.9899L96.2891 76.3026M83.8484 82.4074L91.1271 89.9579M74.4158 88.8044L76.5372 94.2097",
    stroke: "black",
    strokeWidth: 1.98438,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_920_97947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.2813,
    height: 91.2813,
    fill: "white",
    transform: "translate(18.3594 17.8594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/brokenLink.10886ee92bd7ea7e05502a952840e0d0.svg";
export { ForwardRef as ReactComponent };